import styled from "styled-components";

export const AdBannerWrapper = styled.div<{ width: number; height: number }>`
  width: 100%;
  aspect-ratio: ${(p) => p.width / p.height};
  margin-bottom: 20px;
  position: relative;

  .progress-dots {
    display: flex;
    gap: 9px;
    position: absolute;
    bottom: 10px;
    justify-content: center;
    width: 100%;
    z-index: 100;
  }

  .dot {
    width: 10px;
    height: 10px;
    background: #fff;
    border-radius: 10.5px;
    transition: all 0.4s ease;
    border: 1px solid #6436e7;
  }

  .dot.active {
    border-radius: 10.5px;
    width: 31px;
    background: var(--Purple-300, #6436e7);
    transition: all 0.4s ease;
  }
`;

export const AdCardItemWrapper = styled.div<{ width: number; height: number }>`
  display: flex;
  flex-direction: row;
  gap: 12px;
  width: 100%;
  aspect-ratio: ${(p) => p.width / p.height};
  cursor: pointer;

  > img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

export const AdBannerArrow = styled.div<{ isLeft: boolean }>`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 1;
  ${(p) => (p.isLeft ? `left: 16px;` : `right: 16px;`)}
`;
